import { useQuery } from '@tanstack/react-query';
import { parseData } from '../util/data';
import { apiClient } from '../util/http';

export const getAccessibleCompaniesRaw = async (criteria = {}) => {
  const { data } = await apiClient.get('/company', { params: criteria });
  return data;
};

const transformCompanies = (rawData) => rawData?.map((raw) => parseData(raw));

export const getAccessibleCompanies = async (criteria = {}) => {
  const { data } = await getAccessibleCompaniesRaw(criteria);
  return transformCompanies(data);
};

export const useAccessibleCompanies = (criteria) =>
  useQuery({
    queryKey: ['folhas', criteria],
    // Retorna dados crus para o cache comparar primitivos e evitar bugs de referência com o Moment por exemplo
    queryFn: () => getAccessibleCompaniesRaw(criteria),
    staleTime: 1000 * 60 * 10, // 10 minutes
    select: transformCompanies,
    refetchOnWindowFocus: false,
  });
